import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import store from './store/store';
import Cookie from 'js-cookie';

Vue.use(Router);
const defaultLanguage = store.state.defaultLanguage;

const checkForCookie = async () => {
  const token = Cookie.get('bearerToken');

  if (token) return true;

  // await store.dispatch('getUserProfile');

  localStorage.removeItem('vuex');
  return false;
};

const canCreateProject = store => {
  const subscriptions = store.state.authentication.subscriptions;
  const canCreateProject =
    subscriptions?.canCreateProject && !subscriptions?.hasReachedCapacityLimit;

  return canCreateProject;
};

// const canCreateItinerary = store => {
//   const {
//     canCreateItinerary,
//     hasReachedCapacityLimit
//   } = store.state.authentication.subscriptions;
//   const canCreateItineraryOption =
//     canCreateItinerary && !hasReachedCapacityLimit;

//   return canCreateItineraryOption;
// };

const canCreateTemplate = store => {
  const userProfile = store.state.authentication.userProfile;
  const canCreateTemplate = userProfile?.subscription?.name !== 'STANDARD';
  return canCreateTemplate;
};

const deleteEnrollment = async (profileId, projectGroupId) => {
  store.dispatch('deleteMemberSteps', {
    profileId,
    projectGroupId
  });
};

const updateEnrollment = async (enrollmentArray, profileId) => {
  const mapedArray = enrollmentArray.map(enrollObj => {
    const projectGroupId = enrollObj.projectGroupId.replace('#', '');

    store.dispatch('updateProfileEnrollment', {
      profileId,
      projectGroupId,
      query: {
        step: 2
      }
    });
  });

  await Promise.all(mapedArray);
  const res = await store.dispatch('getUserProfile');
  return res;
};

const completeEnrollment = async profile => {
  await checkForCookie();

  if (!profile?.enrollment?.length) return false;

  const enrollmentBelowTwo = profile?.enrollment?.filter(
    element => element?.step < 2
  );

  const hasLogo = profile.logo === null ? false : true;

  //if user doesnt have a logo is the first time therefore send to profile set up
  if (enrollmentBelowTwo?.length > 0 && !hasLogo) {
    return {
      name: 'profileSetup'
    };

    //if user has logo update the enrollment elements that have step one and run again
  } else if (enrollmentBelowTwo?.length > 0 && hasLogo) {
    const profileId = profile.profileId.replace('#', '');

    const res = await updateEnrollment(enrollmentBelowTwo, profileId);

    return completeEnrollment(res.data.user.profile);
  }

  const enrollmentsBelowThree = profile?.enrollment?.filter(
    element => element?.step < 3
  );

  if (enrollmentsBelowThree?.length > 0) {
    const lastIndex = enrollmentsBelowThree.length - 1;
    const {
      type,
      projectId,
      templateFormId,
      projectGroupId
    } = enrollmentsBelowThree[lastIndex];

    const templateList = templateFormId.list;
    const enrollmentType = type;

    let nextEnrollmentRoute;

    //If enrollment direct Registration
    if (enrollmentType === 'DIRECT_REGISTRATION') {
      nextEnrollmentRoute = {
        name: 'viewSelectedProject',
        params: {
          id: projectId.replace('#', ''),
          lang: defaultLanguage
        },
        query: {
          directRegistration: true
        }
      };
    } else if (enrollmentType === 'INVITE') {
      //If invitation enrollment and single templateId
      if (
        templateList.length === 0 ||
        templateList[0] === '#15:0' ||
        templateList[0] === '#16:0'
      ) {
        const pgId = projectGroupId.replace('#', '');
        const profileId = profile.profileId.replace('#', '');

        // need to delete enrollment to prevent infinite loop
        await deleteEnrollment(profileId, pgId);
        await store.dispatch('getUserProfile');

        nextEnrollmentRoute = {
          name: 'dashboard',
          query: {
            'completed-enrollment': projectGroupId.replace('#', '')
          }
        };
      } else {
        nextEnrollmentRoute = {
          name: 'createShowcase',
          query: {
            type: 'enroll'
          }
        };
      }
    }
    return nextEnrollmentRoute;
  }

  // If step is 3
  const enrollmentsBelowFour = profile?.enrollment?.filter(
    element => element?.step < 4
  );

  if (enrollmentsBelowFour?.length > 0) {
    const nextEnrollmentRoute = {
      name: 'createShowcase',
      query: {
        type: 'enroll'
      }
    };
    return nextEnrollmentRoute;
  }

  //If Step 4
  const enrollmentsBelowFive = profile?.enrollment?.filter(
    element => element?.step < 5
  );

  if (enrollmentsBelowFive?.length > 0) {
    return {
      name: 'createShowcase',
      query: {
        type: 'enroll'
      }
    };
  }

  return false;
};

const beforeEnterAccessFlow = async (to, from, next) => {
  const profile = store?.state?.authentication?.userProfile?.profile;
  const isEnrollmentCompleted = await completeEnrollment(profile);

  if (isEnrollmentCompleted) {
    return next(isEnrollmentCompleted);
  }
  return next();
};

const isAdmin = (to, from, next) => {
  const profile = store?.state?.authentication?.userProfile?.profile;

  if (!profile) return next('/login');
  const role = profile?.role;
  if (!role) return next('/home');
  if (role.toLowerCase() !== 'admin') return next('/home');

  return next();
};

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      beforeEnter: async (to, from, next) => {
        const token = Cookie.get('bearerToken');
        const hasProfile = store.state.authentication.userProfile.hasOwnProperty(
          'profile'
        );

        if (!token && !hasProfile) next('/projects');
        else if (token && hasProfile) next('/dashboard');
        else next('/login');
      },
      meta: {
        fullScreenWidth: true
      }
    },

    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('./views/HomeDashboard.vue'),
      beforeEnter: async (to, from, next) => {
        const profile = store?.state?.authentication?.userProfile?.profile;
        if (!profile) {
          return next('/home');
        }

        if (from.name === 'createShowcase') return next();

        const enrollmentProcess = await completeEnrollment(profile);
        if (enrollmentProcess) {
          return next(enrollmentProcess);
        }
        return next();
      }
    },
    {
      path: '/login',
      name: 'login',
      components: {
        login: Login
      }
    },
    {
      path: '/about-us',
      name: 'aboutUs',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/AboutUsView.vue'),
      beforeEnter: async (to, from, next) => {
        const profile = store?.state?.authentication?.userProfile?.profile;

        if (!profile) {
          return next('/login?routeTo=/about-us?section=notifications');
        }

        const enrollmentProcess = await completeEnrollment(profile, next);

        if (enrollmentProcess) {
          if (enrollmentProcess.name === 'aboutUs') {
            return next();
          }
          return next(enrollmentProcess);
        } else next();
      }
    },
    {
      path: '/view-projects',
      name: 'viewProjects',
      component: () => import('./views/ViewProjectsView.vue'),
      beforeEnter: async (to, from, next) => {
        const profile = store?.state?.authentication?.userProfile?.profile;
        if (!profile) {
          return next('/home');
        }
        const enrollmentProcess = await completeEnrollment(profile, next);
        if (enrollmentProcess) {
          return next(enrollmentProcess);
        }
        return next();
      }
    },
    {
      path: '/view-projects/:id?/:lang?',
      name: 'viewSelectedProject',
      meta: { fullScreenWidth: true },
      component: () =>
        import('./views/ViewSelectedProject2/ViewSelectedProject.vue')
    },
    {
      path: '/profiles',
      name: 'profiles',
      component: () =>
        import('./views/BrowseProfilesView/BrowseProfilesView.vue'),
      beforeEnter: beforeEnterAccessFlow
    },
    {
      meta: { fullScreenWidth: true },
      path: '/my-showcases',
      name: 'browseMyShowcases',
      component: () => import('./views/BrowseMyShowcasesView.vue'),
      beforeEnter: beforeEnterAccessFlow
    },
    {
      path: '/showcases',
      name: 'browesShowcases',
      component: () => import('./views/BrowseShowcasesView.vue'),
      beforeEnter: beforeEnterAccessFlow
    },
    {
      path: '/creativities',
      name: 'browseCreativities',
      component: () => import('./views/BrowseCreativitiesView.vue'),
      beforeEnter: beforeEnterAccessFlow
    },
    {
      path: '/my-templates',
      name: 'browseMyTemplates',
      component: () => import('./views/BrowseTemplatesView.vue')
    },
    {
      path: '/view-parent-project/:id/:lang?',
      name: 'browseProjects',
      component: () => import('@/views/BrowseProjectsView.vue'),
      beforeEnter: beforeEnterAccessFlow
    },
    {
      path: '/projects',
      name: 'browseParentAndProjects',
      component: () =>
        import(
          '@/views/BrowseParentAndProjectView/BrowseParentAndProjectView.vue'
        ),
      beforeEnter: beforeEnterAccessFlow
    },
    {
      path: '/create-showcase/:id?',
      name: 'createShowcase',
      meta: { fullScreenWidth: true },
      component: () => import('./views/CreateShowcase/CreateShowcaseView2.vue'),
      beforeEnter: async (to, from, next) => {
        await checkForCookie();
        const profile = store?.state?.authentication?.userProfile?.profile;
        if (!profile) {
          return next('/home');
        }

        const enrollmentProcess = await completeEnrollment(profile, next);
        if (enrollmentProcess) {
          if (enrollmentProcess.name === 'createShowcase') {
            return next();
          }
          return next(enrollmentProcess);
        }
        return next();
      }
    },
    {
      path: '/preview-showcase',
      name: 'previewShowcase',
      meta: { hasBackBtn: true },
      component: () => import('./views/PreviewShowcaseView.vue'),
      beforeEnter: beforeEnterAccessFlow
    },
    {
      meta: { fullScreenWidth: true },
      path: '/showcase/:id/:lang?',
      name: 'viewShowcase',
      component: () => import('./views/ViewShowcaseView/ViewShowcaseView.vue'),
      beforeEnter: beforeEnterAccessFlow
    },
    {
      meta: { fullScreenWidth: true },
      path: '/documents/:id/document-approval/:lang?',
      name: 'viewShowcaseForApproval',
      component: () => import('./views/ViewShowcaseView/ViewShowcaseView.vue')
    },
    {
      meta: { fullScreenWidth: true },
      path: '/profile/:id/:lang?',
      name: 'viewProfile',
      component: () => import('./views/ViewProfileView.vue'),
      beforeEnter: beforeEnterAccessFlow
    },
    {
      path: '/create-project/:id?',
      name: 'createProject',
      component: () =>
        import('./views/CreateNewProject/CreateNewProjectView.vue'),
      beforeEnter: (to, from, next) => {
        return canCreateProject(store) ? next() : next({ name: 'dashboard' });
      }
    },
    {
      path: '/create-template',
      name: 'createTemplate',
      meta: { fullScreenWidth: true },
      component: () =>
        import('./views/CreateTemplateView/CreateTemplateView.vue'),
      beforeEnter: (to, from, next) => {
        const brandName = store?.state?.brand?.brand?.name;
        if (brandName?.toLowerCase() === 'trust') {
          return next();
        }
        return canCreateTemplate(store) ? next() : next({ name: 'dashboard' });
      }
    },
    {
      path: '/revisions',
      name: 'browseRevisions',
      component: () =>
        import('./views/BrowseRevisionsView/BrowseRevisionsView.vue'),
      beforeEnter: beforeEnterAccessFlow
    },
    {
      path: '/revisions/:id',
      name: 'viewRevisions',
      component: () =>
        import('./views/ViewRevisionsView/ViewRevisionsView.vue'),
      meta: { fullScreenWidth: true },
      beforeEnter: beforeEnterAccessFlow
    },
    {
      path: '/templates',
      name: 'templateMarketplace',
      component: () => import('./views/TemplateMarketplaceView.vue'),
      beforeEnter: (to, from, next) => {
        const { allowTemplateMarketPlace } = store?.state?.brand?.brand;
        if (allowTemplateMarketPlace) {
          return next();
        }
        return canCreateTemplate(store) ? next() : next({ name: 'dashboard' });
      }
    },
    {
      path: '/invitations/:token/:inviteeAction',
      name: 'invitations',
      component: () => import('./views/InvitationView.vue')
    },
    {
      path: '/qrcode/:uuid',
      name: 'qr',
      beforeEnter: async (to, from, next) => {
        await checkForCookie();
        const profileRoute = `/profile/`;
        const projectRoute = `/view-projects/`;
        const documentRoute = `/showcase/`;
        const itineraryRoute = '/itinerary/';

        const { uuid } = to.params;
        const routeRes = await store.dispatch('getQrCode', { uuid });

        if (routeRes.status !== 200) next('/qr-code/notfound');

        const custom = routeRes.data.qrcode?.custom;
        const entityId = routeRes.data.qrcode.entityId.replace('#', '');
        const section = routeRes.data.qrcode.entity.toLowerCase();
        const hasProjectId = routeRes?.data?.qrcode?.projectId;

        if (custom) {
          window.location.href = custom;
        }

        switch (section) {
          case 'profile':
            next(`${profileRoute}${entityId}`);
            break;

          case 'project':
            next(`${projectRoute}${entityId}`);
            break;

          case 'document':
            next(
              hasProjectId
                ? `${documentRoute}${entityId}?projectId=${hasProjectId}`
                : `${documentRoute}${entityId}`
            );
            break;

          case 'itinerary':
            next(`${itineraryRoute}${entityId}`);
            break;
          case 'project_group': {
            //entityId return projectGroupId-projectId
            const ids = entityId.split('-');
            next(`/view-projects/${ids[1]}/groups/${ids[0]}`);
          }
        }
      }
    },
    {
      path: '/qr-code/notfound',
      name: 'qrCode404',
      component: () => import('./views/QrCode-404.vue')
    },
    {
      path: '/around-me',
      name: 'aroundMe',
      meta: { fullScreenWidth: true },
      component: () => import('./views/AroundMeView/AroundMeView.vue')
    },
    {
      path: '/around-me/around',
      name: 'aroundMe-around',
      meta: { fullScreenWidth: false },
      component: () => import('./views/AroundMeMoreView/AroundMeMoreView.vue')
    },
    {
      path: '/404',
      name: '404',
      component: () => import('./views/404.vue')
    },
    // don't bring studio in since it's not ready
    // {
    //   path: '/studio',
    //   name: 'studio',
    //   component: () => import('./views/Studio/StudioEditor.vue'),
    //   meta: { fullScreenWidth: true }
    // },
    // {
    //   path: '/studio/editor',
    //   name: 'studioEditor',
    //   component: () => import('./views/Studio/StudioEditor.vue')
    // },
    {
      path: '/view-projects/:id/groups/:groupId/:lang?',
      name: 'viewSelectedProjectGroup',
      meta: { fullScreenWidth: true },
      component: () =>
        import('./views/ViewSelectedProject2/ViewSelectedProject.vue'),
      beforeEnter: beforeEnterAccessFlow
    },
    {
      path: '/signup',
      name: 'signup',
      meta: { fullScreenWidth: true },
      component: () => import('./views/SignUp/SignUpView.vue'),
      beforeEnter: async (to, from, next) => {
        const { allowSignup } = store?.state?.brand?.brand;

        if (allowSignup) {
          await checkForCookie();
          next(true);
        } else {
          next({ name: 'login' });
        }
      }
    },
    {
      path: '/direct-registration/:id/:token',
      name: 'confirmDirectRegistraiton',
      component: () => import('./views/ConfirmEmail.vue'),
      beforeEnter: async (to, from, next) => {
        await checkForCookie();
        next(true);
      }
    },
    {
      path: '/direct-registration/:id/:lang?',
      name: 'directRegistration',
      component: () => import('./views/SignUp/SignUpView.vue'),
      beforeEnter: async (to, from, next) => {
        await checkForCookie();
        next(true);
      }
    },
    {
      path: '/itineraries',
      name: 'browesItineraries',
      component: () => import('./views/BrowseItineraries.vue')
    },
    {
      path: '/itinerary/builder/:id?',
      name: 'itineraryBuilder',
      component: () => import('./views/ItineraryBuilder/ItineraryBuilder2.vue'),
      meta: { fullScreenWidth: true }
    },
    {
      path: '/itinerary/summary/:id?/:lang?',
      name: 'itinerarySummary',
      redirect: `/itinerary/:id?/:lang?`
    },
    {
      path: '/itinerary/:id?/:lang?',
      name: 'itineraryView',
      component: () => import('./views/ItineraryView/ItineraryView.vue'),
      meta: { fullScreenWidth: true }
    },
    {
      path: '/my-itineraries',
      name: 'myItineraries',
      component: () => import('./views/BrowseMyItineraries.vue'),
      meta: { fullScreenWidth: true }
    },
    {
      path: '/reset/:token',
      name: 'resetPassword',
      component: () => import('./views/ConfirmEmail.vue')
    },
    {
      path: '/join-projects',
      name: 'joinProjects',
      component: () => import('./views/JoinProjectsView.vue')
    },
    {
      path: '/profiles-my-projects',
      name: 'profilesMyProjects',
      component: () =>
        import(
          './views/BrowseProfilesMyProjectsView/BrowseProfilesMyProjectsView.vue'
        ),
      beforeEnter: beforeEnterAccessFlow
    },
    {
      path: '/creativities-my-projects',
      name: 'creativitiesMyProjects',
      component: () =>
        import(
          './views/BrowseCreativitiesMyProjectsView/BrowseCreativitiesMyProjectsView.vue'
        ),
      beforeEnter: beforeEnterAccessFlow
    },
    {
      path: '/signup/:language/:token',
      name: 'signupToken',
      component: () => import('./views/ConfirmEmail.vue')
    },
    {
      path: '/profile-setup',
      name: 'profileSetup',
      component: () => import('./views/ProfileUpdateView.vue')
    },
    {
      path: '/terms-and-conditions',
      name: 'termAndConditions',
      component: () => import('./views/TermsAndConditionsView.vue'),
      meta: { fullScreenWidth: true }
    },
    {
      path: '/privacy-policy',
      name: 'privacyPolicy',
      component: () => import('./views/PrivacyPolicyView.vue'),
      meta: { fullScreenWidth: true }
    },
    {
      path: '/network-error',
      name: 'networkError',
      component: () => import('./views/NetworkErrorView.vue'),
      meta: { fullScreenWidth: true }
    },
    {
      path: '/platform-settings',
      name: 'platformSettings',
      component: () =>
        import('./views/PlatformSettingsView/PlatformSettingsView.vue'),
      meta: { fullScreenWidth: true },
      beforeEnter: isAdmin
    },
    {
      path: '/members-to-impersonate',
      name: 'membersToImpersonate',
      component: () =>
        import('./views/MembersToImpersonate/MembersToImpersonate.vue'),
      beforeEnter: beforeEnterAccessFlow
    },
    {
      path: '/subscriptions',
      name: 'subscriptions',
      component: () => import('./views/Subscriptions/Subscriptions.vue')
    },
    {
      path: '/subscription-success',
      name: 'subscriptionsSuccess',
      component: () =>
        import('./views/SubscriptionSuccess/SubscriptionSuccess.vue')
    },
    {
      path: '/latest-members',
      name: 'latestMembers',
      component: () =>
        import('./views/LatestMembersView/LatestMembersView.vue'),
      meta: { fullScreenWidth: true }
    },
    {
      path: '/latest-members-2',
      name: 'latestMembers',
      component: () => import('./views/PortletView/PortletView.vue'),
      meta: { fullScreenWidth: true }
    },
    {
      path: '/latest-members-getting-started',
      name: 'latestMembersGettingStarted',
      component: () =>
        import('./views/PortletGettingStarted/PortletGettingStarted.vue')
    },
    {
      path: '/latest-showcases',
      name: 'latestShowcases',
      component: () =>
        import('./views/LatestShowcasesView/LatestShowcasesView.vue'),
      meta: { fullScreenWidth: true }
    },
    {
      path: '/latest-showcases-2',
      name: 'latestShowcases',
      component: () => import('./views/PortletView/PortletView.vue'),
      meta: { fullScreenWidth: true }
    },
    {
      path: '/latest-showcases-getting-started',
      name: 'latestShowcasesGettingStarted',
      component: () =>
        import('./views/PortletGettingStarted/PortletGettingStarted.vue')
    },
    {
      path: '/latest-itineraries',
      name: 'latestItineraries',
      component: () =>
        import('./views/LatestItinerariesView/LatestItinerariesView.vue'),
      meta: { fullScreenWidth: true }
    },
    {
      path: '/latest-itineraries-2',
      name: 'latestItineraries',
      component: () => import('./views/PortletView/PortletView.vue'),
      meta: { fullScreenWidth: true }
    },
    {
      path: '/latest-itineraries-getting-started',
      name: 'latestItinerariesGettingStarted',
      component: () =>
        import('./views/PortletGettingStarted/PortletGettingStarted.vue')
    },
    {
      path: '/profile-showcases/:id?',
      name: 'profileShowcases',
      component: () =>
        import('./views/ProfileShowcasesView/ProfileShowcasesView.vue'),
      meta: { fullScreenWidth: true }
    },
    {
      path: '/profile-showcases-2/:id?',
      name: 'profileShowcases',
      component: () => import('./views/PortletView/PortletView.vue'),
      meta: { fullScreenWidth: true }
    },
    {
      path: '/profile-showcases-getting-started',
      name: 'profileShowcasesGettingStarted',
      component: () =>
        import('./views/PortletGettingStarted/PortletGettingStarted.vue')
    },
    {
      path: '/portlet',
      name: 'portletView',
      component: () => import('./views/PortletGettingStarted/PortletView.vue')
    },
    { path: '*', component: () => import('./views/404.vue') }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(async (to, from, next) => {
  localStorage.setItem('lastRoute', from.fullPath);
  if (window?.fbq) window.fbq('trackCustom', to.path);
  const openRoutes = [
    'login',
    'invitation',
    'aroundMe',
    'viewSelectedProjectGroup',
    'viewProfile',
    'viewShowcase',
    'browseProjects',
    'browseCreativities',
    'profiles',
    'viewSelectedProject',
    'viewProjects',
    'aroundMe'
  ];
  if (openRoutes.includes(to.name)) {
    return next();
  }

  const { userProfile } = store.state.authentication;

  if (userProfile?.profile?.profileId) return next();

  // Otherwise let's get the userProfile;
  // await store.dispatch('getUserProfile');
  return next();
});

export default router;
